import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { NavDropdown } from 'react-bootstrap'
import TableSolicitudes from '../components/TableSolicitudes'
import PageHeader from '../../../components/pageHeader/PageHeader'
import PageButtons from '../../../components/pageComponents/PageButtons'
import ModalEnabled from '../../../components/modalComponents/ModalEnabled'
import SpinnerLoading from '../../../components/pageComponents/SpinnerLoading'
import SearchContainer from '../../../components/pageComponents/SearchContainer'
import { AuthContext } from '../../../hooks/context/authContext'
import useDidMountEffect from '../../../hooks/useDidMountEffect/useDidMountEffect'
import { useGetRequest } from '../../../hooks/useGetRequest/useGetRequest'
import { useManageGetRequest } from '../../../hooks/useManageGetRequest/useManageGetRequest'

import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest'
import { useGenerarDescargarEliminarArchivo } from '../../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo'
import { initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData } from '../../../helper/utils'
import { getAllDepartamentosAPI, getAllCargosAPI,getAllCuponerasAPI, getAllEstadosAPI, getAllSedesAPI, listarSolicitudesCuponTiempoLibreAPI, listarSolicitudesCuponTiempoLibreDescargarExcelAPI, listarConsumoCuponesTiempoLibreDescargarExcelAPI } from '../../../consumers/backendApisUrls'
import Select from 'react-select';

const AdminSolicitudesCupon = () => {

  const INIT_KEYS = { Cargos: "IdsCargos", Sedes: "IdsSedes", Gerencias: "IdsGerencias", EstadosSolicitud: "IdsEstadosSolicitud", EstadosRegistro: "IdsEstadosRegistro" };

  const {state} = useContext(AuthContext);
  const IdEmpleado = state.user.id_empleado;

  const [formValues, setFormValues] = useState({ Items: [], ExtraData: {}, filters: [], selectedFilters: {} });
  const [allFilters, setAllFilters] = useState([]);

  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({ CurrentPage: 1 });
  const [isLoading, setIsLoading] = useState(true);

  const [modalEnabled, setModalEnabled] = useState({ isEnable: false, component: React.Fragment });

  const [executeGet] = useGetRequest();
  const [executeManageGet] = useManageGetRequest();
  const [executeManagePost] = useManagePostRequest();
  const [downloadAndDelete] = useGenerarDescargarEliminarArchivo();

  const [cuponeraItems, setCuponeraItems] = useState([]);
  const [selectedCuponera, setSelectedCuponera] = useState({});

  const initialPromises = () => {
    return [
      executeGet(getAllCargosAPI()),
      executeGet(getAllSedesAPI()),
      executeGet(getAllDepartamentosAPI()), //getAllAreasAPI()
      executeGet(getAllEstadosAPI()),
      executeGet(getAllEstadosAPI()),
    ]
  }

  const init = async () => {
    setIsLoading(true);
    try {
      await getCuponeras();
      initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
      //await manageSearch();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  const manageSearch = async () => {
    const api = listarSolicitudesCuponTiempoLibreAPI();
    let payload = getPayload();
    await executeManagePost(api, payload, successManageSearchCallback);
  }

  const getPayload = () => {
    return {
      IdEmpleado,
      Criteria: searchCriteria,
      Page: paginator.CurrentPage,
      IdCuponeraTiempoLibre: selectedCuponera?.value,
      ...formValues.selectedFilters
    }
  }

  const successManageSearchCallback = ({ data }) => {
    const { Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage } = data;
    setFormValues(lastData => ({ ...lastData, Items, ExtraData }));
    setPaginator({ TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage });
  }

  const handleUpdatedFilters = (res) => {
    setFormValues(lastData => ({...lastData, filters: res }))
  }

  const handleDownloadExcel = async () => {
    const api = listarSolicitudesCuponTiempoLibreDescargarExcelAPI();
    let payload = getPayload();
    await downloadAndDelete(api, payload);
  }

  const handleDescargarExcelConsumoCupones = async() =>{
    if (!selectedCuponera) {        
        return;
    }
    console.log(selectedCuponera.value);    
    let payload = getPayloadReporte();
    const api = listarConsumoCuponesTiempoLibreDescargarExcelAPI();
    await downloadAndDelete(api, payload);
  }

  const getPayloadReporte = () => {
        return {
            IdCuponeraTiempoLibre: selectedCuponera.value
        }
    }


  const handleCleanSearch = () => {
    setFormValues({...formValues, selectedFilters: null});
  }




  const getCuponeras = async () => {
    const api = getAllCuponerasAPI();
    await executeManageGet(api, (res) => sucessInitCallback(res), false);
  }

  const sucessInitCallback = ({ data }) => {
    const items = data.map(o => ({value: o.IdCuponeraTiempoLibre, label: o.Nombre}));
    setCuponeraItems(items);
    if (items.length > 0)
      setSelectedCuponera(items[0])
  }

  

  useDidMountEffect(() => {
    manageSearch();
  }, [paginator.CurrentPage, formValues.selectedFilters, selectedCuponera])

  useDidMountEffect(() => {
    jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
  }, [formValues.ExtraData])


  

  useEffect(() => {
    init();
  }, [])

  if (isLoading) return <SpinnerLoading />

  return (
    <>
      <ModalEnabled modalEnabled={modalEnabled} setModalEnabled={setModalEnabled} refreshPage={manageSearch} />
      <PageHeader title="Gestión de Solicitudes de Cupones de tiempo libre" />

      <SelectProcesoSolicitud items={cuponeraItems} selectedItem={selectedCuponera} setSelectedItem={setSelectedCuponera}/>

      <SearchContainer searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} setPaginator={setPaginator} manageSearch={manageSearch} addCleanSearch={handleCleanSearch}>
        <ButtonsWrapper>
          <PageButtons  >

           {formValues.ExtraData.PuedeConfigurar && 
            <NavDropdown className="generic-button-dropdown font-gothan-light" title={<span className='generic-button-dropdown-title'>Acciones</span>}>
              <Link to="adminCuponeraTiempoLibre/listaCuponera" className='dropdown-item'>Lista Cuponera</Link>
              <Link to="adminCuponeraTiempoLibre/listaCupones" className='dropdown-item'>Lista Cupones</Link>
              
            </NavDropdown>            
            }

            <NavDropdown className="generic-button-dropdown font-gothan-light" title={<span className='generic-button-dropdown-title'>Reportes</span>}>
              <span className='dropdown-item' 
                  style={{ cursor: 'pointer' }}
                  onClick={handleDownloadExcel}
                >Reporte Solicitudes de Cupones</span>
              <span className='dropdown-item' 
                  style={{ cursor: 'pointer' }}
                  onClick={handleDescargarExcelConsumoCupones}
                >Reporte Consumo de Cupones</span>
           </NavDropdown>

          </PageButtons>
          
        </ButtonsWrapper>
      </SearchContainer>
      <TableSolicitudes formValues={formValues} setFormValues={setFormValues} setModalEnabled={setModalEnabled} paginator={paginator} setPaginator={setPaginator} keys={INIT_KEYS} />
    </>
  )
}

export default AdminSolicitudesCupon;

const SelectProcesoSolicitud = ({ items, selectedItem, setSelectedItem }) => (
  <div className='col-sm-4 mt-2 ml-2'>
    <Select 
      options={items}
      value={selectedItem}
      onChange={(res) => setSelectedItem({...res})}
      placeholder="Seleccionar cuponera"
    />
  </div>
)

const ButtonsWrapper = styled.div`
  display: block;
  @media (max-width: 796px){
    display: none;
  }
`;